import { t } from 'i18next'

import * as yup from 'yup'

/**
 * Form constants
 */

const SUBJECT = 'subject'

const COURSE_CODE = 'course_code'
const GRADE_LEVEL = 'grade_level'
const TERM = 'term'

const TITLE = 'title'
const DESCRIPTION = 'description'
const COURSE_OBJECTIVES = 'course_objectives'
const LEARNING_OBJECTIVES = 'learning_objectives'
const ASSESSMENT = 'assessment'
const COURSE_MATERIALS = 'course_materials'
const TECHNOLOGIES = 'technologies'
const INSTRUCTIONS = 'instructions'
const OUTLINE = 'outline'
const LEARNER_SUPPORT = 'learner_support'
const PLAGIARISM = 'plagiarism'

const COURSE_COMPONENTS = 'components'

// image
// materials

/**
 * Form model
 */
const formModel = () => {
  return {
    [TITLE]: {
      label: `${t('common.course-title')}`,
      name: TITLE,
      required: true,
    },
    [SUBJECT]: {
      label: `${t('common.course-subject')}`,
      name: SUBJECT,
      required: true,
    },
    [DESCRIPTION]: {
      label: `${t('common.course-description')}`,
      name: DESCRIPTION,
    },
    [COURSE_CODE]: {
      label: `${t('common.course-code')}`,
      name: COURSE_CODE,
    },
    [GRADE_LEVEL]: {
      label: `${t('common.course-grade')}`,
      name: GRADE_LEVEL,
    },
    [TERM]: {
      label: `${t('common.course-term')}`,
      name: TERM,
    },
    [COURSE_OBJECTIVES]: {
      label: `${t('common.course-objectives')}`,
      name: COURSE_OBJECTIVES,
    },
    [LEARNING_OBJECTIVES]: {
      label: `${t('lessons.learning-objectives')}`,
      name: LEARNING_OBJECTIVES,
    },
    [ASSESSMENT]: {
      label: `${t('common.assessment-and-measurments')}`,
      name: ASSESSMENT,
    },
    [COURSE_MATERIALS]: {
      label: `${t('common.course-materials')}`,
      name: COURSE_MATERIALS,
    },
    [TECHNOLOGIES]: {
      label: `${t('common.course-technologies')}`,
      name: TECHNOLOGIES,
    },
    [INSTRUCTIONS]: {
      label: `${t('common.course-instructions-and-activities')}`,
      name: INSTRUCTIONS,
    },
    [OUTLINE]: {
      label: `${t('common.course-outline')}`,
      name: OUTLINE,
    },
    [LEARNER_SUPPORT]: {
      label: `${t('common.learner-support')}`,
      name: LEARNER_SUPPORT,
    },
    [PLAGIARISM]: {
      label: `${t('common.plagiarism')}`,
      name: PLAGIARISM,
    },
    [COURSE_COMPONENTS]: {
      label: `${t('common.performance-expectations')}`,
      name: COURSE_COMPONENTS,
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [SUBJECT]: null,

  [COURSE_CODE]: '',
  [GRADE_LEVEL]: null,
  [TERM]: null,

  [TITLE]: '',
  [DESCRIPTION]: '',
  [COURSE_OBJECTIVES]: '',
  [LEARNING_OBJECTIVES]: '',
  [ASSESSMENT]: '',
  [COURSE_MATERIALS]: '',
  [TECHNOLOGIES]: '',
  [INSTRUCTIONS]: '',
  [OUTLINE]: '',
  [LEARNER_SUPPORT]: '',
  [PLAGIARISM]: `${t('common.plagiarism-default')}`,

  [COURSE_COMPONENTS]: [],
}

/**
 * Form data validation
 */
export const validationSchema = () =>
  yup.object().shape({
    [SUBJECT]: yup
    .object()
    .shape({
      title: yup
        .string()
        .nullable()
        .required(`${t('required-error-message')}`),
    })
    .nullable()
    .required(`${t('errors.required-error-message')}`),

    [COURSE_CODE]: yup
      .string()
      .nullable()
      .required(`${t('errors.required-error-message')}`),

    [TITLE]: yup
      .string()
      .nullable()
      .required(`${t('errors.required-error-message')}`),

    [DESCRIPTION]: yup
      .string()
      .nullable()
  })

export default formModel
